function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#fff"
    },
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#449df7",
      strokeWidth: "1.5px"
    },
    cx: 4,
    cy: 4,
    r: 3.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlue);
export default __webpack_public_path__ + "static/media/IconBlue.f673fba7a0c65639766bfc269032d03c.svg";
export { ForwardRef as ReactComponent };